export const readSessionRecord = <T>(key: string): T | null => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

export const readStoredUserSummary = <T>(): T | null =>
  readSessionRecord<T>('user_summary');

export const readStoredUser = <T>(): T | null => readSessionRecord<T>('user');
